(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-pills"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-pills')) {
  customElements.define('variant-pills', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.variant-pill').forEach(btn => {
        btn.addEventListener('click', () => {
          this.querySelectorAll('.variant-pill').forEach(b => b.setAttribute('aria-pressed', 'false'));
          btn.setAttribute('aria-pressed', 'true');

          const card = this.closest('product-card');
          if (!card) return;

          // Ár frissítés
          const price = btn.dataset.priceFormatted;
          if (price) {
            const priceEl = card.querySelector('product-price');
            if (priceEl) priceEl.innerHTML = price;
          }

          // Kép csere
          const imgUrl = btn.dataset.variantImage;
          if (imgUrl) {
            const img = card.querySelector('img');
            if (img) { img.src = imgUrl; img.srcset = imgUrl; }
          }

          // Link + kosár frissítés
          const variantUrl = btn.dataset.variantUrl;
          if (variantUrl) {
            const link = card.querySelector('a.product-card__link');
            if (link) link.href = variantUrl;
          }

          const variantId = btn.dataset.variantId;
          if (variantId) {
            const input = card.querySelector('input[name="id"]');
            if (input) { input.value = variantId; input.disabled = false; } const quickAdd = card.querySelector('quick-add-component'); if (quickAdd) quickAdd.setAttribute('data-quick-add-button', 'add'); const addBtn = card.querySelector('.quick-add__button--add'); if (addBtn) addBtn.disabled = false;
          }
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
